'use strict';

var _commonjsHelpers = require('./_commonjsHelpers.js');
var index = require('../node_modules/@material-ui/core/esm/SvgIcon/index.js');

function _interopNamespaceDefaultOnly (e) { return { __proto__: null, 'default': e }; }

var index__namespace = /*#__PURE__*/_interopNamespaceDefaultOnly(index);

var require$$3 = /*@__PURE__*/_commonjsHelpers.getAugmentedNamespace(index__namespace);

module.exports = require$$3;
